import { alertError } from '@/Support/Common/Functions/alertError'
import { AxiosError, AxiosResponse } from 'axios'

export interface TryFetchOptions {
  on401?: (error: AxiosError) => {} | void
  on402?: (error: AxiosError) => {} | void
  on403?: (error: AxiosError) => {} | void
  on404?: (error: AxiosError) => {} | void
  on422?: (error: AxiosError) => {} | void
  onSuccess?: (response: AxiosResponse) => {} | void
}

export const tryFetch = async (
  url: string,
  method: string = 'get',
  data?: unknown,
  options: TryFetchOptions = {},
) => {
  try {
    const response = await window.axios({ method, url, data })

    if (options.onSuccess) {
      options.onSuccess(response)
    }

    return response
  } catch (e) {
    const error = e as AxiosError
    const statusError = error.response?.status
    switch (true) {
      case statusError === 401 && !!options.on401:
        options.on401(error)
        break

      case statusError === 402 && !!options.on402:
        options.on402(error)
        break

      case statusError === 403 && !!options.on403:
        options.on403(error)
        break

      case statusError === 404 && !!options.on404:
        options.on404(error)
        break

      case statusError === 422 && !!options.on422:
        options.on422(error)
        break

      default:
        alertError(error, statusError)
        break
    }
  }
}

export const tryFetchGet = async (
  url: string,
  options: TryFetchOptions = {},
  data?: unknown,
) => {
  return tryFetch(url, 'get', data, options)
}

export const tryFetchPost = async (
  url: string,
  options: TryFetchOptions = {},
  data?: unknown,
) => {
  return tryFetch(url, 'post', data, options)
}

export const tryFetchPut = async (
  url: string,
  options: TryFetchOptions = {},
  data?: unknown,
) => {
  return tryFetch(url, 'put', data, options)
}

export const tryFetchDelete = async (
  url: string,
  options: TryFetchOptions = {},
  data?: unknown,
) => {
  return tryFetch(url, 'delete', data, options)
}
